module.exports = __webpack_public_path__ + "img/folder-full.ffa6bfc5.svg";